import { I18n } from 'react-redux-i18n'
import { isValidText } from '../../../utils/helpers'

export default (brand) => {
  let errors = {}

  if (!brand.name) errors.name = I18n.t('dashboard_errors_required-field')
  else if (!isValidText(brand.name)) errors.name = I18n.t('dashboard_errors_not-valid-name')

  return errors
}
